module.exports = __webpack_public_path__ + "img/all_active.c34f615d.png";